import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Accordion, AccordionItem } from '@tmhcc-ng-lib/framwork/models';
import { EventTypeFromGrid } from 'libs/framwork/grid/src/lib/shared/grid.interface';
import { has } from 'libs/util/has-value';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'hcc-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {
  constructor(private cd: ChangeDetectorRef) {}
  @Input() accordionData: Accordion;
  @Input() gridTemplate = false;
  @Output() emitSelectedValue = new EventEmitter<{
    key: any;
    value: any;
  }>();

  @Output() gridButtonAction = new EventEmitter<{
    action: string;
    label: string;
    value: string;
  }>();

  @Output() linkClickedEvent = new EventEmitter<string>();

  isToggleData = [];

  @Input() selectedSearchBy: string = "PolicyNumber"; 
  @Input() enteredSearchText: string; 
  @Output() onData = new EventEmitter<{
  selectedSearchBy: string;
  enteredSearchText: string;
  }>();
  
  

  ngOnInit() {
    // this.accordionData.accordion.forEach(d => {
    //   d['isToggle'] = false;
    // });
  }

  collapseStatusChange(data) {
    this.accordionData.accordion.forEach(d => {
      d.isToggle = d.id === data.id ? !d.isToggle : false;
    });
    this.clickedLink(data);
  }

  emitEventData(event, accordion: AccordionItem) {
    if (accordion.buttonGroup) {
      accordion.buttonGroup.forEach(btn => {
        if (btn.hasOwnProperty('isDisabled')) {
          if (btn.action == accordion.targetAction && event.length) {
            btn.isDisabled = false;
          } else {
            btn.isDisabled = true;
          }
        }
      });
    }
  }

  getCheckboxRequiredStatus(gridDefination) {
    if (has(gridDefination, 'isCheckbox')) {
      return gridDefination.isCheckbox;
    } else {
      return true;
    }
  }

  clickedLink(data) {
    this.linkClickedEvent.emit(data);
  }

  selectedValues($event, id, accordion) {
    if ($event.key === EventTypeFromGrid.view) {
      this.openModal($event.value);
    } else {
      this.emitSelectedValue.emit({
        key: id,
        value: $event.value
      });
      this.emitEventData($event.value, accordion);
    }
    this.linkClickedEvent.emit($event.value);
  }

  gridButtonClikAction(buttonRef) {
    this.gridButtonAction.emit(buttonRef);
  }

  openModal(data) {
    this.emitSelectedValue.emit({
      key: 'openView',
      value: data
    });
  }

  searchByClicked()
  {
      this.accordionData.accordion[0].loading = true;
      this.accordionData.accordion[0].gridDefination.data = [];
      this.accordionData.accordion[0].isServiceError = false;
      this.cd.detectChanges();
      this.onData.emit({ selectedSearchBy: this.selectedSearchBy, enteredSearchText: this.enteredSearchText });      
  }
}
